import ConventionProviderExhibitor from "models/convention-api/v1/ConventionProviderExhibitor"

export const getExhibitorName = (exhibitor: ConventionProviderExhibitor) => {
  if (exhibitor.institution?.name) return exhibitor.institution.name

  return "No name found for exhibitor id - " + exhibitor.id
}

export const getExhibitorLocation = (exhibitor: ConventionProviderExhibitor) => {
  if (!exhibitor.institution) return ""
  if (!exhibitor.institution.region) return exhibitor.institution.city
  if (!exhibitor.institution.city) return exhibitor.institution.region

  return `${exhibitor.institution.city}, ${exhibitor.institution.region}`
}

export const getExhibitorChatStatus = (exhibitor: ConventionProviderExhibitor) => {
  return exhibitor.institution?.chatAvailable?.status ?? "off"
}

export const getExhibitorImages = (exhibitor: ConventionProviderExhibitor) => {
  if (exhibitor.cover_photo_url)
    return [
      {
        id: exhibitor.cover_photo_url,
        src: exhibitor.cover_photo_url,
        alt: "",
      },
    ]

  return []
}
